/**
 * @generated SignedSource<<488fd6e7ce225e0553009cde085ace88>>
 * @relayHash bfccae9109711a7e3cf772109245064c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID m_v8yukQlxGn4893IQkkUGTA

import { ConcreteRequest } from 'relay-runtime';
export type AtmosphereSignOutMutation$variables = Record<PropertyKey, never>;
export type AtmosphereSignOutMutation$data = {
  readonly signOut: boolean;
};
export type AtmosphereSignOutMutation = {
  response: AtmosphereSignOutMutation$data;
  variables: AtmosphereSignOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signOut",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtmosphereSignOutMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtmosphereSignOutMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "m_v8yukQlxGn4893IQkkUGTA",
    "metadata": {},
    "name": "AtmosphereSignOutMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1a6e3b5f6b663d648281322c374e4295";

export default node;
